<template>
  <MeetingModule>
    <c-input
      v-model="model.message"
      name="message"
      type="textarea"
      autogrow
      label="Instructie"
      :placeholder="instructionPlaceholder"
      lazy-rules
      :rules="[
        (val) => !!val || 'Instructie is verplicht',
        (val) =>
          val.length >= 20 ||
          'De instructie moet minimaal 20 karakters bevatten',
      ]"
      hide-bottom-space
      @update:model-value="modelUpdate"
    />
  </MeetingModule>
</template>

<script setup>
import { computed, onMounted } from "vue";
import MeetingModule from "components/meeting/modules/MeetingModule.vue";

// Define the model
const model = defineModel({
  required: true,
  type: Object,
});

const isStepCompleted = defineModel("isStepCompleted");

const instructionPlaceholder = computed(() => {
  const { meeting_type } = model.value;

  switch (meeting_type) {
    case "group_meeting":
    case "transition_meeting":
      return "Bijv: Beste collega, de bespreking is geopend! Zie de tijdlijn voor belangrijke data. Ik zal zorgen voor een broodje kroket tijdens de vergaderingen. Veel succes met invullen! Groetjes, Corry Coördinator.";
    default:
      return "Bijv: Beste collega, de bespreking is geopend! Zie de tijdlijn voor belangrijke data. Ik zal zorgen voor een broodje kroket tijdens de speeddates. Veel succes met invullen! Groetjes, Corry Coördinator.";
  }
});

// Update model value
const modelUpdate = (value) => {
  isStepCompleted.value = value && value.length >= 20;
};

onMounted(() => {
  // Check the model onMounted
  modelUpdate(model.value.message);
});
</script>
